import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import classes from './Payments.scss';
import Spinner from '../../components/UI/Spinner/Spinner';

import PaymentNavigation from '../../components/Payment/PaymentNavigation/PaymentNavigation';

import CreditCard from '../../components/Payment/CreditCard/CreditCard';
import EMI from '../../components/Payment/EMI/EMI';
import Paypal from '../../components/Payment/Paypal/Paypal';
import NetBanking from '../../components/Payment/NetBanking/NetBanking';
import UPI from '../../components/Payment/UPI/UPI';
import CreditCashPool from '../../components/Payment/CreditCashPool/CreditCashPool';
import Wallets from '../../components/Payment/PaymentWallets/PaymentWallets';

import MobileBackButton from '../../components/UI/Mobile/MobileBackButton/MobileBackButton';
import HeadingH3 from '../../components/UI/Headings/HeadingH3/HeadingH3';

import DynamicForm from '../../components/Payment/DynamicForm/DynamicForm';
import Media from 'react-media';

import qs from 'qs';

import { getBalance, payNow, setCardNameValidation, setCardNumberValidation, setCVVValidation } from '../../store/actions/index'; 

class Payments extends Component {

    state = {
        isdSelectActive: false,
        creditCardRawValue: '',
        creditCardValue: '',
        nameRawValue: '',
        expiryDateRawValue: '',
        expiryDateValue: '',
        cvvRawValue: '',
        binDetails: null
    }

    onCreditCardChange = (event) => {
        // console.log(event);
        // let url = 'http://localhost:3000/payment/getBinDetails';
        // if (prod) {
        //     url = 'https://secure.yatra.com/quicksilvercontroller/payment/getBinDetails';
        // }
        // if (event.target.rawValue.length > 6) {
        //     let binDetailObject = {
        //         cno: event.target.rawValue, 
        //         passthrough: false, 
        //         product: "b2bdom", 
        //         superPnr: this.props.superPnr
        //     }
        //     axios.post(url, binDetailObject).then((response) => {
        //         this.setState({
        //             binDetails: response.data
        //         }, () => {
        //             console.log(this.state.binDetails);
        //         })
        //     })
        //     .catch(error => {
        //         console.log(error);
        //     })
        // };
        this.setState({creditCardRawValue: event.target.rawValue, creditCardValue: event.target.value})
    }; 
    onNameChange = (event) => this.setState({ nameRawValue: event.target.value }); 
    onExpiryDateChange = (event) => this.setState({ expiryDateRawValue: event.target.value, expiryDateValue: event.target.value }); 
    onCvvChange = (event) => this.setState({ cvvRawValue: event.target.value }); 
    onCreditCardTypeChanged = (type) => this.setState({creditCardType: type}); 

    componentWillMount() {
        if (this.props.userBalance === null) {
            this.props.onGetBalance(localStorage.getItem('ssoToken'));
        }
    }

    payButtonHandler = (e) => {
        e.preventDefault();
        const params = new URLSearchParams(this.props.location.search);
        const isInt = JSON.parse(params.get("isInt"));
        const product = isInt ? 'b2bint' : 'b2bdom';
        let paymentOptionParametersString = "";
        if(this.props.paymentMode === "cc" || this.props.paymentMode === "dc") {
            if(this.state.creditCardRawValue.trim() === "") {
                this.props.onSetCardNumberValidation();
                return;
            }
            if(this.state.nameRawValue.trim() === "") {
                this.props.onSetCardNameValidation();
                return;
            }
            if(this.state.cvvRawValue.trim() === "") {
                this.props.onSetCVVValidation();
                return;
            }
            paymentOptionParametersString = `|ctype=VISA|isCardInternational=false|saveQBCard=false|cexpm=${this.state.expiryDateRawValue.substring(0, 2)}|cexpy=${'20' + this.state.expiryDateRawValue.substring(3,5)}|address_check_rdo=Domestic|processTyperdo=OTP|cno=${this.state.creditCardRawValue}|cardholder_name=${this.state.nameRawValue}|ccsc=${this.state.cvvRawValue}`;
        }
        if(this.props.paymentMode === "nb") {
            paymentOptionParametersString = `|bankCode=${this.props.bankCode}|prBank=${this.props.bankCode}`
        }
        if(this.props.paymentMode === 'paypal') {
            paymentOptionParametersString = `|currency=${this.props.selectedPaypalOption.code}|forexRate=${this.props.selectedPaypalOption.rate}|forexAmount=${this.props.amountDetails.totalAmount}`
        }
        if(this.props.paymentMode === 'cp') {
            paymentOptionParametersString = `|poolType=cashPool`;
        }
        let paymentOptionParameters = `merchant=yatra|product=${product}|payop=${this.props.paymentMode}|origin=${this.props.origin}|destination=${this.props.destination}|tripType=O${paymentOptionParametersString}`;

        const paymentObject = {
            paymentOptionParameters: paymentOptionParameters,
            amountDisplayed: this.props.totalPrice,
            merchant: "yatra",
            uuid: this.props.pid,
            searchId: this.props.searchId,
            superPnr: this.props.superPnr,
            ttid: this.props.superPnr,
            flightIdCSV: params.get('flightIdCSV'),
            sc: params.get('sc'),
            paymentMode: "FULL",
            unique: "tag",
            mode: "Background",
            isSR: false,
            bpc: true,
            client: "DESKTOP",
            card_bin_type: "DEBIT",
            discountingStatus: false,
            cardDiscountingStatus: false,
            otherDiscountingStatus: false,
            additionalPayment: false,
            discount: 0,
            promoType: "",
            promoCode: "",
            ylp: 0,
            paymentProcessType: "SECURE",
            cvvRequired: true,
            product: product,
            tenant: "B2B"
        }
        this.props.onPayNow(qs.stringify(paymentObject));
    }

    toggleClickedHandler = () => {
        this.setState(prevState => {
            return {isdSelectActive: !prevState.isdSelectActive}
        })
    }


    render() { 

        let paymentContent = null;
        let paymentContentInner = null;

        if (this.props.paymentInfoLoading) {
            paymentContentInner = <Spinner/>;
        } else {
            paymentContentInner = <React.Fragment>
                        <div className={classes.BoxLeft}>
                            <PaymentNavigation />
                        </div>
                        <Media query="(max-width: 599px)">
                            {matches =>
                            matches ? this.props.paymentOptionsMobile ?
                            <div className={`pt-10 pb-10 pl-8 pr-8 u-flex f-1 f-column phone-pl-4 phone-pr-4 phone-pt-6 phone-pb-6`}>
                                {
                                    this.props.paymentMode === 'cc' || this.props.paymentMode === 'dc' ? <CreditCard 
                                        cardType={this.state.binDetails !== null ? this.state.binDetails.cardType : 'EMPTY'}
                                        creditCardChange={this.onCreditCardChange} 
                                        expiryDateChange={this.onExpiryDateChange} 
                                        nameChange={this.onNameChange} 
                                        cvvChange={this.onCvvChange} 
                                        typeChange={this.onCreditCardTypeChanged}
                                        creditCardValue={this.state.creditCardRawValue}
                                        creditCardOriginalValue={this.state.creditCardValue}
                                        expiryDateValue={this.state.expiryDateRawValue}
                                        nameValue={this.state.nameRawValue}
                                        cvvValue={this.state.cvvRawValue}
                                        clicked={this.payButtonHandler} data={this.props.paymentOptions.cc} /> : 
                                            this.props.paymentMode === 'nb' ? <NetBanking clicked={this.payButtonHandler} data={this.props.paymentOptions.nb} /> : 
                                                this.props.paymentMode === 'emi' ? <EMI  /> : 
                                                        this.props.paymentMode === 'paypal' ? <Paypal clicked={this.payButtonHandler} data={this.props.paymentOptions.paypal} /> : 
                                                            this.props.paymentMode === 'upi' ? <UPI data={this.props.paymentOptions.upi} /> : 
                                                                this.props.paymentMode === 'cp' ? <CreditCashPool clicked={this.payButtonHandler} data={this.props.paymentOptions.cp} /> : 
                                                                    this.props.paymentMode === 'spiceMoney' ? <Wallets clicked={this.payButtonHandler} data={this.props.paymentOptions.spiceMoney} /> : 
                                                                        this.props.paymentMode === 'payMonk' ? <Wallets clicked={this.payButtonHandler} data={this.props.paymentOptions.payMonk} /> :
                                                                            this.props.paymentMode === 'oxigen_b2b' ? <Wallets clicked={this.payButtonHandler} data={this.props.paymentOptions.oxigen_b2b} /> :  
                                                                                this.props.paymentMode === 'bankIt' ? <Wallets clicked={this.payButtonHandler} data={this.props.paymentOptions.bankIt} /> : 
                                                                                    this.props.paymentMode === 'jcash' ? <Wallets clicked={this.payButtonHandler} data={this.props.paymentOptions.jcash} /> : null
                                }
                        </div> : null : <div className={`pt-10 pb-10 pl-8 pr-8 u-flex f-1 f-column phone-pl-4 phone-pr-4 phone-pt-6 phone-pb-6`}>
                                {
                                    this.props.paymentMode === 'cc' || this.props.paymentMode === 'dc' ? <CreditCard 
                                        cardType={this.state.binDetails !== null ? this.state.binDetails.cardType : 'EMPTY'}
                                        creditCardChange={this.onCreditCardChange} 
                                        expiryDateChange={this.onExpiryDateChange} 
                                        nameChange={this.onNameChange} 
                                        cvvChange={this.onCvvChange} 
                                        typeChange={this.onCreditCardTypeChanged}
                                        creditCardValue={this.state.creditCardRawValue}
                                        creditCardOriginalValue={this.state.creditCardValue}
                                        expiryDateValue={this.state.expiryDateRawValue}
                                        nameValue={this.state.nameRawValue}
                                        cvvValue={this.state.cvvRawValue}
                                        clicked={this.payButtonHandler} data={this.props.paymentOptions.cc} /> : 
                                            this.props.paymentMode === 'nb' ? <NetBanking clicked={this.payButtonHandler} data={this.props.paymentOptions.nb} /> : 
                                                this.props.paymentMode === 'emi' ? <EMI  /> : 
                                                        this.props.paymentMode === 'paypal' ? <Paypal clicked={this.payButtonHandler} data={this.props.paymentOptions.paypal} /> : 
                                                            this.props.paymentMode === 'upi' ? <UPI data={this.props.paymentOptions.upi} /> : 
                                                                this.props.paymentMode === 'cp' ? <CreditCashPool clicked={this.payButtonHandler} data={this.props.paymentOptions.cp} /> : 
                                                                    this.props.paymentMode === 'spiceMoney' ? <Wallets clicked={this.payButtonHandler} data={this.props.paymentOptions.spiceMoney} /> : 
                                                                        this.props.paymentMode === 'payMonk' ? <Wallets clicked={this.payButtonHandler} data={this.props.paymentOptions.payMonk} /> :
                                                                            this.props.paymentMode === 'oxigen_b2b' ? <Wallets clicked={this.payButtonHandler} data={this.props.paymentOptions.oxigen_b2b} /> :  
                                                                                this.props.paymentMode === 'bankIt' ? <Wallets clicked={this.payButtonHandler} data={this.props.paymentOptions.bankIt} /> : 
                                                                                    this.props.paymentMode === 'jcash' ? <Wallets clicked={this.payButtonHandler} data={this.props.paymentOptions.jcash} /> : null
                                }
                            </div> }
                        </Media>
            </React.Fragment>
        }

        paymentContent = (
            <React.Fragment>
                <Media query="(max-width: 599px)">
                    {matches =>
                        matches ? <div className={`u-flex justify-content-center align-items-center mb-3 pl-2 pr-2 pt-4 pb-4 u-backgroundColorWhite`} style={{
                            marginLeft: '-1rem',
                            marginRight: '-1rem'
                        }}>
                        <MobileBackButton onClick={() => this.props.history.push({
                                    pathname: "/reviews/addons",
                                    search: this.props.location.search
                                    })}/>
                        <div className={'mx-auto'}>
                        <HeadingH3 size={16} weight="Medium" color="Dark">Payments</HeadingH3>
                        </div>
                    </div> : null
                    }
                </Media>
                <div className={`u-width100percent u-maxHeight500 u-height490 u-phone-boxShadowNone u-phone-height100percent u-phone-maxHeight100percent u-flex f-row u-backgroundColorWhite u-generalBoxShadow phone-f-column u-borderRadius4`}>
                    {paymentContentInner}
                </div>
                <DynamicForm handleSubmit={this.handleSubmit} />
            </React.Fragment>
        );

        return (
            <div className={`phone-pl-2 phone-pr-2`}>
                {paymentContent}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        paymentMode: state.ui.paymentMode,
        paymentInfoLoading: state.payments.paymentInfoLoading,
        paymentOptions: state.payments.paymentOptions, 
        bookingDetailsLoading: state.payments.bookingDetailsLoading, 
        totalPrice: state.payments.totalPrice,
        superPnr: state.farePrice.generalData.superPnr,
        userBalance: state.auth.userBalance,
        pid: state.farePrice.generalData.pricingId,
        searchId: state.farePrice.generalData.data.searchId,
        bankCode: state.ui.bankCode,
        paymentOptionsMobile: state.ui.paymentOptionsMobile,
        selectedPaypalOption: state.payments.selectedPaypalOption,
        amountDetails: state.payments.amountDetails,
        origin: state.payments.origin,
        destination: state.payments.destination,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onPayNow: (paymentObject) => dispatch(payNow(paymentObject)),
        onSetCardNumberValidation: () => dispatch(setCardNumberValidation()),
        onSetCardNameValidation: () => dispatch(setCardNameValidation()),
        onSetCVVValidation: () => dispatch(setCVVValidation()),
        onGetBalance: (ssoToken) => dispatch(getBalance(ssoToken))
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Payments));


// WEBPACK FOOTER //
// ./src/containers/Payments/Payments.js